export function giftNotificationAmountLabel(notification) {
  const amount = notification?.money_amount ?? notification?.points_amount;
  const type = notification?.notification_type || 'GIFT_CARD';

  if (type === 'VOUCHER') {
    const label =
      notification?.voucher_type === 'SERVICE_FEE'
        ? 'Free service fee'
        : notification?.voucher_type === 'DELIVERY'
          ? 'Free delivery'
          : 'Voucher';
    return `${label} voucher (${amount} EGP value)`;
  }

  if (type === 'WALLET_TRANSFER') {
    return `${amount} EGP wallet balance`;
  }

  return `${amount} EGP gift card`;
}

export function giftNotificationTitle(notification) {
  const type = notification?.notification_type || 'GIFT_CARD';
  if (type === 'VOUCHER') return 'Voucher received!';
  if (type === 'WALLET_TRANSFER') return 'Balance received!';
  return 'Gift received!';
}

export function giftNotificationIcon(notification) {
  const type = notification?.notification_type || 'GIFT_CARD';
  if (type === 'VOUCHER') return '🎫';
  if (type === 'WALLET_TRANSFER') return '💰';
  return '🎁';
}

export function normalizeGiftStatus(raw) {
  if (!raw) return null;
  const summary = raw.summary || {};
  return {
    ...raw,
    created_count: summary.total_created ?? raw.created_count ?? 0,
    received_count: summary.total_received ?? raw.received_count ?? 0,
    unread_count: summary.unread_notifications ?? raw.unread_count ?? 0,
  };
}
